import Notification from '../../../common/components/notification/notification.vue';
import logoutBar from '../header-commons/logout/logout.vue';
import headerBase from '../header-commons/lib/header-base';
import { inject } from 'vue';
import { useLanguage } from '../../../applications/invoice-request/composables/language';
export default {
	extends: headerBase,
	setup() {
		const { onlyHungarian } = useLanguage();
		const userHasDszk = inject('userHasDszk');
		return {
			onlyHungarian,
			userHasDszk
		};
	},
	data() {
		return {
			userHasDSZK: false
		};
	},
	components: {
		notification: Notification,
		logoutBar
	}
};
